<template>
  <div class="accordion_main">
    <div class="accordion-wrap">
      <div class="accordion-head" 
        ref="head"
        @click="toggleOpen" 
        @mouseenter="!isTouch && toggleHover(1)"
        @mouseleave="!isTouch && toggleHover(0)"
        @mousemove="!isTouch && handlerMouseMove()"
      >
        <div class="head-text">
          <h3 v-html="content.main_accordion_title"></h3>
          <p v-html="content.main_accordion_excerpt"></p>
        </div>
        <div class="arrow-wrap">
          <div class="icon-holder">
            <svg xmlns="http://www.w3.org/2000/svg" width="37.072" height="22.071" viewBox="0 0 37.072 22.071">
              <path id="Path_7885" data-name="Path 7885" d="M8040.093,499.112l15-15-15-15" transform="translate(502.648 -8036.558) rotate(90)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="5"/>
            </svg>
          </div>
        </div>
        <!-- <ImageFollowMouse 
          :isHover="isHover" 
          :image="content.mouse_follow_image"
          :y="mouseY"
          :x="mouseX"
        /> -->
      </div>
      <div class="accordion-hidden">
        <div class="accordion-hidden-content">
          <div class="accordion-hidden-image">
            <CarouselProds 
              :indexActive="activeProd"
              :imagesArray="content.main_accordion_image"
              :canToggle.sync="canToggle" 
            />
          </div>
          <div class="accordion-inner-accordions-wrap">
            <AccordionInner 
              v-for="(accordions, index) in content.main_accordion_rows " 
              :key="index" 
              :data="content.main_accordion_rows[index]"
              :activeProd.sync="activeProd"
              :indexOrder="index"
              :canToggle="canToggle"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionInner from './AccordionInner.vue'
import CarouselProds from './CarouselProds.vue'

export default {
  name: 'AccordionMain',
  props: ['content'],
  components:{
    AccordionInner,
    CarouselProds
  },
  data(){
    return{
      isHover: false,
      isOpen: false,
      mouseX: 0,
      mouseY: 0,
      headHeight: 0,
      headWidth: 0,
      isTouch: false,
      activeProd: 0,
      canToggle: true
    }
  },
  methods: {
    toggleOpen(event){
      let parent = event.currentTarget.parentNode;
      let alreadyOpenAccordion = document.querySelector('.accordion-inner-mask.open')

      if(alreadyOpenAccordion) alreadyOpenAccordion.classList.remove('open')
      if(parent.classList.contains('open')){
        this.isOpen = false
        parent.classList.remove('open');
        setTimeout(() => {
          this.activeProd = 0;
        }, 500);
        return;
      }else{
        let selectedSibling = document.querySelector('.accordion-wrap.open');
        
        if(selectedSibling) selectedSibling.classList.remove('open');
        parent.classList.toggle('open');
        this.isOpen = !this.isOpen
        this.isHover = this.isOpen === true ? false : this.isHover;
        
        setTimeout(() => {
          
          let accordionInnerFirst = parent.querySelectorAll('.accordion-inner-wrap')[0]
          let accordionInnerFirstMask = accordionInnerFirst.querySelector('.accordion-inner-mask')
          let bodyRect = document.body.getBoundingClientRect().top;
          let parentRect = parent.getBoundingClientRect().top;
          //accordionInnerFirstMask.classList.add('open')
          this.activeProd = 0;
          this.scrollTo((parentRect - bodyRect) - 100 , 1000)
        }, 500);
        
      }
      
    },
    scrollTo(elementTo, duration){
      if (duration <= 0) return;
      var scrollTop = document.documentElement.scrollTop;   
      var difference = elementTo - scrollTop;
      var perTick = difference / duration * 10;
  
      setTimeout(() => {
          document.documentElement.scrollTo(0, scrollTop + perTick);
          if (scrollTop === elementTo ) return;
          this.scrollTo(elementTo, duration - 10);
      }, 1);
    },
    toggleHover(enter){
      this.isHover = enter ? true : false;
      this.isHover = this.isOpen ? false : this.isHover;
    },
    handlerMouseMove(){
      this.mouseX = this.$refs.head.getBoundingClientRect().left - event.clientX;
      this.mouseY = this.$refs.head.getBoundingClientRect().top - event.clientY;    
             
    },
    resize(){
      this.headHeight = this.$refs.head.clientHeight
      this.headWidth = this.$refs.head.clientWidth
    }
  },
  beforeCreate(){
    this.isTouch = 'ontouchstart' in window;
  },
  mounted(){
    
    document.addEventListener('resize', this.resize)
    this.resize()
  },
  beforeDestroy(){
    document.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" >
  .accordion_main:nth-child(1){
    border-bottom: 1px solid rgba($color: #707070, $alpha: 0.1);
  }
  .accordion_main{
    position: relative;
    width: 100%;
    margin-bottom: 80px;
    @media screen and (max-width: 900px){
      overflow: hidden;
    }
    .accordion-wrap{
      position: relative;
      width: 100%;
    }
    .accordion-head{
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      cursor: pointer;
      >div{
        flex: 1 0 50%;
        &.arrow-wrap{
          text-align: right;
          width: 40px;
          .icon-holder{
            position: relative;
            width: 40px;
            height: auto;
            transform: rotate(0);
            margin-right: 0;
            margin-left: auto;
            transition: transform .5s ease-out;
            @media screen and (max-width: 900px){
              width: 20px;
              svg{
                width: 20px;
              }
            }
          }
          path{
            stroke: #33586E;
            transition: stroke .25s ease-out;
          }
        }
        @media screen and (max-width: 900px){
          flex: auto;
        }
      }
      h3{
        font-size: 40px;
        line-height: 49px;
        color: #33586E;
        transition: color .25s ease-out;
        @media screen and (max-width: 900px){
          font-size: 22px;
          line-height: 27px;
        }
      }
      p{
        line-height: 28px;
        padding: 30px 0;
        @media screen and (max-width: 900px){
          padding-bottom: 50px;
          font-size: 14px;
          line-height: 24px;
        }
      }
      &:hover{
        svg{
          path{
            stroke: #68A926;
          }
        }
        h3{
          color: #68A926;
        }
      }
    }
    .accordion-hidden{
      position: relative;
      width: 100%;
      margin-bottom: 30px;
      overflow: hidden;
      max-height: 0;
      transition: max-height .5s ease-out;
      .accordion-hidden-content{
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        .accordion-hidden-image{
          flex: 1 0 30%;
          max-width: 30%;
          align-self: flex-start;
          width: 100%;
          img{
            display: block;
            width: 100%;
          }
        }
        .accordion-inner-accordions-wrap{
          position: relative;
          flex: 1 0 65%;
          max-width: 65%;
        }
        @media screen and (max-width: 900px){
          flex-direction: column;
          justify-content: center;
          .accordion-hidden-image,.accordion-inner-accordions-wrap{
            flex: 1 0 auto;
            max-width: 100%;
          }
          .accordion-hidden-image{
            height: 250px;
            overflow: hidden;
            margin-bottom: 50px;
            img{
              position: relative;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
    .accordion-wrap.open{
      .accordion-head{
        .icon-holder{
          transform: rotate(-180deg);
        }
        svg{
          path{
            stroke: #68A926;
          }
        }
        h3{
          color: #68A926;
        }
      }
      .accordion-hidden{
        max-height: 2000px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// AccordionMain.vue?34f50e3f